const productionApiUrl = 'https://api.nomoreemptytables.com'

const devApiUrl = 'http://nmet-api.test'
// const devApiUrl = 'http://sms.ro'
//
let url = {}

if (process.env.NODE_ENV === 'production') {
  url.url = productionApiUrl
  url.clientUrl = 'https://promobilesite.com'
  // url.clientUrl = 'http://sms.ro'
  url.shortUrl = 'https://jointhevip.me'
  url.viral = 'http://etik.cc'
  url.viralShort = 'https://jointhevip.com'
  url.s3Link = 'https://s3.us-east-2.amazonaws.com/nmet-static-files'

  url.gcuDomainURL = 'http://staging.giftcardyou.com/'
} else {
  url.url = devApiUrl
  url.clientUrl = 'https://api.nomoreemptytables.com'
  url.shortUrl = 'http://joinvip.ro'
  url.viral = 'http://shorturl.ro'
  url.viralShort = 'http://jointhevip.ro'
  url.s3Link = 'https://s3.us-east-2.amazonaws.com/nmet-static-files'
  // url.gcuDomainURL = 'http://localhost:8000/'
  url.gcuDomainURL = 'http://giftcardapps.test/'
}

export default url



// WEBPACK FOOTER //
// ./src/config.js